import { render, staticRenderFns } from "./PdfPrescription.vue?vue&type=template&id=3c6a4494&scoped=true"
import script from "./PdfPrescription.vue?vue&type=script&lang=js"
export * from "./PdfPrescription.vue?vue&type=script&lang=js"
import style0 from "./PdfPrescription.vue?vue&type=style&index=0&id=3c6a4494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6a4494",
  null
  
)

export default component.exports